"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateResult = exports.parseWithTimezone = exports.parseUtc = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
/**
 * Parses a DateInput and returns a Day.js instance in UTC mode.
 *
 * @param {DateInput} input - The input date to parse. Can be a number, string, Date object, or a Day.js instance.
 * @returns {dayjs.Dayjs} A Day.js instance representing the input date in UTC mode.
 * @throws {Error} If the input date is invalid.
 */
const parseUtc = (input) => {
    validateInput(input);
    const result = (0, dayjs_1.default)(input).utc();
    validateResult(result);
    return result;
};
exports.parseUtc = parseUtc;
/**
 * Parses a DateInput and returns a Day.js instance in the specified timezone.
 *
 * @param {DateInput} input - The input date to parse. Can be a number, string, Date object, or a Day.js instance.
 * @param {string} timezone - The timezone to use for the resulting Day.js instance.
 * @returns {dayjs.Dayjs} A Day.js instance representing the input date in the specified timezone.
 * @throws {Error} If the input date is invalid.
 */
const parseWithTimezone = (input, timezone) => {
    validateInput(input);
    // If input is a string like '2024-10-05T23:59:59', treat it as local to the timezone
    const result = dayjs_1.default.tz(input, timezone); // This ensures the input is localized to the given timezone
    validateResult(result);
    return result;
};
exports.parseWithTimezone = parseWithTimezone;
/**
 * Validates the input date.
 * @param {DateInput} input - The input date to validate.
 * @throws {Error} If the input date is undefined.
 * @returns {void}
 */
const validateInput = (input) => {
    if (!(0, dayjs_1.default)(input).isValid()) {
        throw new Error('Invalid date');
    }
};
/**
 * Validates the result date.
 * @param {dayjs.Dayjs} result - The result date to validate.
 * @throws {Error} If the result date is invalid.
 * @returns {void}
 */
const validateResult = (result) => {
    if (!result.isValid()) {
        throw new Error('Invalid date specified.');
    }
};
exports.validateResult = validateResult;
//# sourceMappingURL=parser.js.map